// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Tiny pub-sub so a feature page (e.g. InsightsPage's ADR-027 "review my
 * progress" CTA) can ask the Amy drawer to open with a prefilled prompt,
 * without threading Amy's open-state through every route. AppShell owns
 * that state and is the sole subscriber (see AppShell.tsx); a plain
 * `window` CustomEvent avoids adding a React Context provider just for
 * this one cross-cutting signal.
 *
 * The prompt is only ever INSERTED into Amy's composer for the user to
 * review/edit (AmyChat.tsx's `insertPrompt`, same principle as example
 * prompts and voice dictation) — never auto-sent.
 */
const EVENT_NAME = "bb:open-amy-with-prompt"

export function openAmyWithPrompt(prompt: string): void {
  window.dispatchEvent(new CustomEvent<string>(EVENT_NAME, { detail: prompt }))
}

/** Returns an unsubscribe function. */
export function onOpenAmyWithPrompt(handler: (prompt: string) => void): () => void {
  const listener = (event: Event) => handler((event as CustomEvent<string>).detail)
  window.addEventListener(EVENT_NAME, listener)
  return () => window.removeEventListener(EVENT_NAME, listener)
}
